export const AD_LIGHT_STORAGE_KEY = 'adlight';
export const AD_LIGHT_HTML_ATTR = 'data-adlight';
export const AD_RESERVED_CLASS = 'ad-reserved';
export const AD_RESERVED_SIZED_CLASS = 'ad-reserved-sized';
export const AD_RESERVED_CAPPED_CLASS = 'ad-reserved-capped';
export const IN_CONTENT_SLOT_ID = 'in-content-slot';
export const IN_CONTENT_SLOT_BLOCK_NAME = 'ad/in-content-slot';
export const CONNATIX_LIVE_BLOCK_NAME = 'acf/connatix-live-block';
export const IN_CONTENT_ADLIGHT_KEEP = new Set([CONNATIX_LIVE_BLOCK_NAME, 'acf/read-next']);
export const AD_LIGHT_ALLOWED_PLACEMENTS = ['sidebar_1', 'top_header'] as const;

export const isAdLightAllowedPlacement = (placement: string): boolean =>
  (AD_LIGHT_ALLOWED_PLACEMENTS as readonly string[]).includes(placement);

export const inContentSlotReservedMinStyle = (minHeightPx: number): Record<string, string> => ({
  '--ad-reserved-min': `${minHeightPx}px`,
});

export const shouldSuppressInContentInner = (blockName: string | undefined, suppressAds: boolean): boolean => {
  if (!suppressAds) return false;
  if (!blockName) return true;
  return !IN_CONTENT_ADLIGHT_KEEP.has(blockName);
};

export const shouldReserveInContentSlot = (blockNames: Array<string | undefined>): boolean => {
  const names = blockNames.filter((blockName): blockName is string => Boolean(blockName));
  if (names.length === 0) return true;
  return names.every(blockName => shouldSuppressInContentInner(blockName, true));
};

export const shouldApplyAdLightHint = ({
  search,
  storageValue,
}: {
  search: string;
  storageValue: string | null;
}): boolean => {
  const query = search.startsWith('?') ? search.slice(1) : search;
  const adlightParam = new URLSearchParams(query).get('adlight');
  if (adlightParam === 'false' || adlightParam === '0') return false;
  return storageValue === 'true';
};

export const isAdLightDomHintActive = (): boolean => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  try {
    const fromAttr = document.documentElement.getAttribute(AD_LIGHT_HTML_ATTR) === 'true';
    const fromStorage = localStorage.getItem(AD_LIGHT_STORAGE_KEY);
    return shouldApplyAdLightHint({
      search: window.location.search,
      storageValue: fromAttr || fromStorage === 'true' ? 'true' : fromStorage,
    });
  } catch {
    return false;
  }
};

export const applyAdLightDom = (enabled: boolean): void => {
  if (typeof document === 'undefined') return;
  if (enabled) {
    document.documentElement.setAttribute(AD_LIGHT_HTML_ATTR, 'true');
    return;
  }
  document.documentElement.removeAttribute(AD_LIGHT_HTML_ATTR);
};

const adLightReservedHideSelector = AD_LIGHT_ALLOWED_PLACEMENTS.map(
  placement => `:not([data-placement="${placement}"])`,
).join('');

export const AD_LIGHT_CRITICAL_CSS = `html[${AD_LIGHT_HTML_ATTR}='true'] .${AD_RESERVED_CLASS}${adLightReservedHideSelector}{display:none!important;aspect-ratio:auto!important;min-height:0!important}`;

export const AD_LIGHT_BOOTSTRAP_SCRIPT = `(function(){try{if(/[?&]adlight=(false|0)(?:&|$)/.test(location.search))return;if(localStorage.getItem('${AD_LIGHT_STORAGE_KEY}')==='true')document.documentElement.setAttribute('${AD_LIGHT_HTML_ATTR}','true');}catch(e){}})();`;
